import { render } from "./MeusAtalhos.vue?vue&type=template&id=b979975c&scoped=true&ts=true"
import script from "./MeusAtalhos.vue?vue&type=script&lang=ts"
export * from "./MeusAtalhos.vue?vue&type=script&lang=ts"

import "./MeusAtalhos.vue?vue&type=style&index=0&id=b979975c&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b979975c"]])

export default __exports__